import { render, staticRenderFns } from "./ProjectFunding.vue?vue&type=template&id=62a7090c"
import script from "./ProjectFunding.vue?vue&type=script&lang=js"
export * from "./ProjectFunding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports